import { WizardShell } from 'components/forms';
import useCurrentUser from 'hooks/useCurrentUser';
import { type FC, useCallback, useState } from 'react';
import { type BciSegurosFormData, initialBciSegurosFormData } from 'services/types/bciSegurosForm';

import ContractorAndConfigStep from './components/ContractorAndConfigStep';
import ProposalAndPaymentStep from './components/ProposalAndPaymentStep';
import QuoteResultsStep from './components/QuoteResultsStep';
import VehicleAndInsuredStep from './components/VehicleAndInsuredStep';

const steps = ['Vehículo y Asegurado', 'Contratante y Seguro', 'Cotización', 'Propuesta'];

const BciSegurosQuoteForm: FC = () => {
  const currentUser = useCurrentUser();
  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState<BciSegurosFormData>(initialBciSegurosFormData);
  const [isLoading, setIsLoading] = useState(false);

  const handleNext = useCallback(() => setActiveStep((s) => s + 1), []);
  const handleBack = useCallback(() => setActiveStep((s) => s - 1), []);
  const handleFormDataChange = useCallback((updates: Partial<BciSegurosFormData>) => {
    setFormData((prev) => ({ ...prev, ...updates }));
  }, []);

  const renderStepContent = () => {
    switch (activeStep) {
      case 0:
        return (
          <VehicleAndInsuredStep
            formData={formData}
            onFormDataChange={handleFormDataChange}
            onNext={handleNext}
            setIsLoading={setIsLoading}
          />
        );
      case 1:
        return (
          <ContractorAndConfigStep
            formData={formData}
            onFormDataChange={handleFormDataChange}
            onNext={handleNext}
            onBack={handleBack}
            setIsLoading={setIsLoading}
            businessUnitId={currentUser?.businessUnitIds?.[0] ?? 0}
          />
        );
      case 2:
        return (
          <QuoteResultsStep
            formData={formData}
            onFormDataChange={handleFormDataChange}
            onNext={handleNext}
            onBack={handleBack}
            setIsLoading={setIsLoading}
          />
        );
      case 3:
        return <ProposalAndPaymentStep formData={formData} onBack={handleBack} />;
      default:
        return null;
    }
  };

  return (
    <WizardShell
      title="Cotizar Seguro"
      subtitle="Automotriz"
      steps={steps}
      activeStep={activeStep}
      isLoading={isLoading}
    >
      {renderStepContent()}
    </WizardShell>
  );
};

export default BciSegurosQuoteForm;
